export default __webpack_public_path__ + "static/media/marvel-hulk.d1af5fe5.jpg";